// extracted by mini-css-extract-plugin
export default {"wrapper":"Link_wrapper__knbei"};